/* eslint-disable array-callback-return */
/* eslint-disable arrow-parens */
/* eslint-disable no-unused-expressions */
import {
  Component, Input, Output, EventEmitter, OnDestroy, OnInit, OnChanges,
} from "@angular/core";
import {
  PurchaseOrderModel,
  purchaseOrderModelListFactory,
  purchaseOrderModelFactory,
  PurchaseOrderCategory,
  itsmPurchaseOrderModelListFactory,
} from "../../purchase-order/purchase-order.model";
import {PurchaseOrderService} from "../../purchase-order/purchase-order.service";
import {Subscription} from "rxjs/Subscription";
import {TARGET_SYSTEM, DAAS_TARGET_SYSTEMS} from "../../helpers/app-constants";
import {HasuraGraphqlService} from "../../graphql/hasura-graphql-service";
import {Query} from "../../graphql/query-constant";
import { AppSettingsService } from "../../app-settings/app-settings.service";
import { NavigationEnd, Router } from "@angular/router";

@Component({
  selector: "purchase-order-card",
  templateUrl: "./purchase-order-edit-card.template.pug",
})
export class PurchaseOrderEditCardComponent implements OnInit, OnChanges, OnDestroy {
  private subscription: Subscription;
  @Input()
  set projectId(value: string) {
    if (value) {
      this._projectId = value;
      this.getPurchaseOrdersFromProject(this._projectId);
    }
  }

  @Input()
  set purchaseOrdersType(value: string) {
    if (value) {
      switch (value) {
        case "NONE":
          this._purchaseOrdersType = value;
          this.purchaseOrdersToLoad = this.purchaseOrdersToLoad.slice(0, 1);
          this.enableDartOffersOnGrid = false;
          break;
        case "SOLUTION":
        case "OFFER":
          this._purchaseOrdersType = value;
          this.enableDartOffersOnGrid = value === "OFFER";
          while (this.purchaseOrdersToLoad.length < 2) { // At least 2 elements are required
            this.purchaseOrdersToLoad.push(purchaseOrderModelFactory());
          }
          this.purchaseOrdersCategory = PurchaseOrderCategory.customerPO;
          this.updateAddNewPoButtonAvailability(this.purchaseOrdersToLoad);
          break;
        default:
          break;
      }
    }
  }

  @Input()
  targetSystem: string;

  @Input()
  isMAActive: boolean;

  @Input()
  isMpc: boolean;

  @Output() purchaseOrdersExistEvent = new EventEmitter<boolean>();
  purchaseOrdersITSM: any[] = [];
  purchaseOrdersToLoad: PurchaseOrderModel[] = purchaseOrderModelListFactory([{}]);
  purchaseOrdersCategory: PurchaseOrderCategory = PurchaseOrderCategory.customerPO;
  _projectId: string;
  _purchaseOrdersType: string;
  showOrdersType: boolean = false;
  showSelectPOLink: boolean = true;
  firstTimeVisit: boolean = false;
  gridsReadOnlyInputs: boolean = false;
  enableDartOffersOnGrid: boolean = false;
  disableAddNewPOButton: boolean = false;
  displaySavingMessage: boolean = false;
  disableSavingButton: boolean = false;
  error: Error;
  isDirty: boolean = false;
  disableRadioButtons: boolean = false;
  isDisabled: boolean = false;
  por18_2_flag: boolean = false;
  allowedTargetSystem: boolean = false;
  isMonthlyPOSelected: boolean = false;

  constructor(private purchaseOrderService: PurchaseOrderService,
    private hasuraGqlService: HasuraGraphqlService,
    private appSettingsService: AppSettingsService,
    private router: Router,
    ) {}


  disableUI() {
    return this.isDisabled;
  }

  publishChange(value: string) {
    // Convert the string value to boolean
    const boolValue = value === "true";
    this.disableRadioButtons = boolValue;
    this.purchaseOrderService.monthlyPOChange.next(boolValue);
  }

  showMonthlyPO(changes: any) {
    if (this.por18_2_flag && changes.targetSystem && changes.targetSystem.currentValue) {
      this.targetSystem = changes.targetSystem.currentValue;
      this.allowedTargetSystem = !(DAAS_TARGET_SYSTEMS.includes(this.targetSystem));
    }
  }

  ngOnChanges(changes: any) {
    if (this.por18_2_flag && changes.isMpc && changes.isMpc.currentValue) {
      this.isMpc = changes.isMpc.currentValue;
      this.allowedTargetSystem = false;
    }
    this.showMonthlyPO(changes);
  }

  async ngOnInit() {
    let por18_2_tmc = false;
    [por18_2_tmc] = await Promise.all([
      this.appSettingsService.getFeaturePermission(
        "POR18-2_TMC",
        this.projectId,
      ),
    ]);
    this.por18_2_flag = por18_2_tmc;

    this.allowedTargetSystem = !(DAAS_TARGET_SYSTEMS.includes(this.targetSystem) || this.isMpc);

    this.subscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.showMonthlyPO({targetSystem: {currentValue: this.targetSystem}});
      }
    });
  }

  getPurchaseOrdersFromProject = async (projectId) => {
    // const {itsmPurchaseOrders, tmcPurchaseOrders} =
    //   await this.purchaseOrderService.getPurchaseOrders(projectId, {isInItsm: true});

    Query.PO.variables.projectId = projectId;
    const params = {
      projectId,
      query: Query.PO,
      uiAction: "LIST-PO",
    };
    const purchaseOrders = await this.hasuraGqlService.getResponseFromHasura(params);
    if (this.por18_2_flag === false && purchaseOrders && purchaseOrders.body && purchaseOrders.body.data && purchaseOrders.body.data.purchase_order && purchaseOrders.body.data.purchase_order.length > 0){
      purchaseOrders.body.data.purchase_order = purchaseOrders.body.data.purchase_order.filter(po => !po.monthlyPo);
    }
    if (purchaseOrders && purchaseOrders.body && purchaseOrders.body.data &&
      purchaseOrders.body.data.purchase_order && purchaseOrders.body.data.purchase_order.length > 0) {
      const _tmcPurchaseOrders = purchaseOrders.body.data.purchase_order.filter(po => po.isSelected);

      if (_tmcPurchaseOrders.length && _tmcPurchaseOrders[0].monthlyPo) {
        this.isDisabled = true;
        this.isMonthlyPOSelected = true;
      }

      const _itsmPurchaseOrder = purchaseOrders.body.data.purchase_order.filter(po => po.isInItsm);
      this.purchaseOrdersToLoad = purchaseOrderModelListFactory(
        (_tmcPurchaseOrders.length ? _tmcPurchaseOrders : [{}]),
      );
      this.purchaseOrdersITSM = itsmPurchaseOrderModelListFactory(_itsmPurchaseOrder.length ?
        _itsmPurchaseOrder : []);
    }
    // this.purchaseOrdersITSM = itsmPurchaseOrders;
    // this.purchaseOrdersToLoad = purchaseOrderModelListFactory(
    //   (tmcPurchaseOrders.length ? tmcPurchaseOrders : [{}]),
    // );

    // Logic for First Time - After Times
    if (this.purchaseOrdersToLoad.length === 1 && this.purchaseOrdersToLoad[0].purchaseOrderITSMId === "") {
      // First Time Specific Logic
      this.showOrdersType = true;
      this.firstTimeVisit = true;
      if (this.purchaseOrdersToLoad.findIndex(it => it.pendingPO) >= 0) {
        this.purchaseOrdersCategory = PurchaseOrderCategory.pendingPO;
      }
      if (this.purchaseOrdersToLoad.findIndex(it => it.perSignedSOW) >= 0) {
        this.purchaseOrdersCategory = PurchaseOrderCategory.perSignedSow;
      }
    } else { // Second or After Visit Specific Logic
      this.gridsReadOnlyInputs = true;
      this.purchaseOrdersExistEvent.emit(true);
    }
    // Update the Add New PO Button
    this.updateAddNewPoButtonAvailability(this.purchaseOrdersToLoad);
  };

  getPurchaseOrders() {
    return this.purchaseOrdersToLoad;
  }

  // This in theory will save the user created Purchase orders ()
  async savePurchaseOrders() {
    try {
      this.error = null;
      this.displaySavingPurchaseOrders(true);
      const purchaseOrdersArray = this.getPurchaseOrders();
      await this.purchaseOrderService.savePurchaseOrders(purchaseOrdersArray, this._projectId);
    } catch (ex) {
      this.error = ex;
      this.displaySavingPurchaseOrders(false);
      throw this.error;
    }
  }

  displaySavingPurchaseOrders(savingActive) {
    this.disableSavingButton = savingActive;
    this.displaySavingMessage = savingActive;
    this.disableAddNewPOButton = savingActive;
  }

  newPoSelected(newSelectedPo, poIndex) {
    // Update the PO that was selected
    this.purchaseOrdersToLoad[poIndex].purchaseOrderNumber = newSelectedPo.purchaseOrderNumber;
    this.purchaseOrdersToLoad[poIndex].purchaseOrderDescription = newSelectedPo.purchaseOrderDescription;
    this.purchaseOrdersToLoad[poIndex].purchaseOrderId = newSelectedPo.purchaseOrderId;
    this.purchaseOrdersToLoad[poIndex].purchaseOrderITSMId = newSelectedPo.purchaseOrderITSMId;
    this.purchaseOrdersToLoad[poIndex].pendingPO = newSelectedPo.pendingPO;
    this.purchaseOrdersToLoad[poIndex].perSignedSOW = newSelectedPo.perSignedSOW;
    this.purchaseOrdersToLoad[poIndex].dartOffers = newSelectedPo.dartOffers;
    this.purchaseOrdersToLoad[poIndex].monthlyPo = newSelectedPo.monthlyPo;
    // this.purchaseOrdersToLoad[poIndex] = newSelectedPo; // This line cycles the site, can you guess why?
    // Update the Add new PO button visibility
    this.updateAddNewPoButtonAvailability();
    this.isDirty = true;
  }

  updateAddNewPoButtonAvailability(purchaseOrdersParam = null) {
    if (this._purchaseOrdersType !== "NONE") {
      const purchaseOrdersArray = (purchaseOrdersParam === null) ? this.getPurchaseOrders() : purchaseOrdersParam;
      this.disableAddNewPOButton = purchaseOrdersArray.findIndex(
        po => !po.purchaseOrderNumber.trim().length || !po.purchaseOrderDescription.trim().length,
      ) >= 0;
    }
  }

  addNewPO() {
    this.purchaseOrdersToLoad.push(purchaseOrderModelFactory());
    this.disableAddNewPOButton = true;
    this.isDirty = true;
  }

  removedPO(removedPOIndex) {
    if (removedPOIndex >= 0 && removedPOIndex < this.purchaseOrdersToLoad.length) {
      this.purchaseOrdersToLoad.splice(removedPOIndex, 1);
      this.updateAddNewPoButtonAvailability();
      this.isDirty = true;
    }
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
